import { Box, Text, Tooltip } from '@chakra-ui/react';
import { Handle, Position, NodeProps } from 'react-flow-renderer';
import { useParams } from 'react-router-dom';

import { BUILDER_MODE_V1_LAYOUT } from 'pages/BuilderModeV1/constants';
import styles from 'pages/BuilderMode/MapTab/MapIndicatorNode/styles';

interface MapIndicatorNodeData {
  direction: string;
  label: string;
  block_name: string;
  obj_name: string;
  index: number;
  obj_id: number;
  formula: string;
}

const MapIndicatorNodeV1 = ({ data }: NodeProps<MapIndicatorNodeData>) => {
  let inputHandlePos: Position;
  let outputHandlePos: Position;
  const { blockId } = useParams();

  const isSameBlock = blockId === `${data.obj_id}`;

  if (data.direction === 'TB') {
    inputHandlePos = Position.Top;
    outputHandlePos = Position.Bottom;
  } else {
    inputHandlePos = Position.Left;
    outputHandlePos = Position.Right;
  }

  const formula = data?.formula?.replace(/["']/g, '') || '';
  const chipBackground = isSameBlock
    ? BUILDER_MODE_V1_LAYOUT.mapSameBlockChipBg
    : BUILDER_MODE_V1_LAYOUT.mapOtherBlockChipBg;

  return (
    <Box style={styles.node}>
      <Handle type='target' position={inputHandlePos} />
      <Tooltip
        placement='top'
        hasArrow
        arrowSize={15}
        fontSize='md'
        aria-label={formula || ''}
        label={formula || ''}
      >
        <Text
          sx={styles.label}
          title={data.label}
          aria-label={data.label}
          fontFamily={'regular_roboto'}
        >
          {data.label}
        </Text>
      </Tooltip>

      <Text
        sx={{ ...styles.chip, color: 'white' }}
        title={data.block_name}
        aria-label={data.obj_name}
        backgroundColor={chipBackground}
        fontFamily={'regular_roboto'}
      >
        {data.obj_name}
      </Text>

      <Handle type='source' position={outputHandlePos} />
    </Box>
  );
};

export default MapIndicatorNodeV1;
